import { IResponseDataBridgeClient } from './IResponseDataBridgeClient';
import SignalsService from '../services/core/SignalsService';

export default class NativeResponseDataBridgeClient implements IResponseDataBridgeClient {
    private nativeBridge: any;
    private signalsService: SignalsService;

    constructor(signalsService: SignalsService) {
        this.signalsService = signalsService;
        this.nativeBridge = (window as any).jsBridgeResponseData;
    }

    public packResponse(fileName: string): void {
        this.nativeBridge.packResponse(fileName);
    }

    public initResponse(useExistingData: boolean, useHybridResponse: boolean): Promise<void> {
        return this.nativeBridge.initResponse(useExistingData, useHybridResponse);
    }

    public async setData(key: string, value?: string): Promise<void> {
        this.nativeBridge.setData(key, value);
        return Promise.resolve();
    }

    public getData(key: string): string | null {
        return this.nativeBridge.getData(key);
    }

    public hasExistingData(allowHybridResponse: boolean, hybridResponseURL: string | null, pirateToken: string): void {
        this.nativeBridge.hasExistingData(allowHybridResponse, hybridResponseURL, pirateToken);
    }

    public backupAndClearResponseData(): void {
        console.warn('backupAndClearResponseData is not supported in native mode');
        this.signalsService.emit('backupResponseDataFailed', 'Not supported in native mode');
    }

    public waitForPendingWrites(timeoutMs?: number): Promise<void> {
        return Promise.resolve(); // Native bridge writes are synchronous
    }
} 